import { useState } from 'react';
import ChevronDownIcon from '@assets/icons/chevron-down.svg';
import ChevronUpIcon from '@assets/icons/chevron-up.svg';
import { Toggler } from '@routes/profile-bar/styled.tsx';

export const ChevronToggler = ({ onChangeAction }: { onChangeAction?: () => void }) => {
    const [isDown, setIsDown] = useState(true);
    return (
        <Toggler
            onClick={() => {
                if (onChangeAction) onChangeAction();
                setIsDown(!isDown);
            }}
        >
            {' '}
            {isDown ? <ChevronDownIcon /> : <ChevronUpIcon />}
        </Toggler>
    );
};
